import { plugins } from 'common'

import { app } from '@/main'

const handleRequestSuccess = (config) => {
  const { $alert } = app.config.globalProperties

  $alert.removeGroup('info')

  return config
}

const handleResponseErrors = (error) => {
  const { $alert } = app.config.globalProperties
  $alert.removeGroup('error')

  const errors = []
  const alertConfig = {
    severity: 'error',
    summary: 'Not available now',
    detail: '',
    group: 'info',
    closable: false
  }

  if (error.response) {
    const { data, status } = error.response
    if (status === 404) {
      const msg = `
        Unfortunately, this tour is not available at the moment.
        If you are sure you want to book it, please contact us by phone or through the form on the contact page.
      `
      errors.push(msg)
      alertConfig.severity = 'info'
    } else errors.push(data.message || 'Something went wrong. Try later :(')
  } else errors.push('Something went wrong. Try later :(')

  alertConfig.detail = errors.join('/n')
  $alert.add(alertConfig)

  return Promise.reject(error)
}

const instance = plugins.createApi()

instance.interceptors.request.use(handleRequestSuccess, undefined)

instance.interceptors.response.use(undefined, handleResponseErrors)

export default instance
